<template>
    <div class="component">
        <div class="nav space_center" :class="[ showNav ? 'show_nav hover_line_showly' : 'hide_nav leave_line_showly']">
            <div class="logo_box">
                <router-link to="/">
                    <img src="../assets/images/logo.png" alt="">
                </router-link>
            </div>
            <div class="menu_box" @click="showPopup">
                <span class="iconfont iconicon-07 menu"></span>
            </div>
        </div>
        <div class="distance"></div>
        <div class="menu_popup">
            <van-popup v-model="show" position="right" closeable :style="{ width: '100%', height: '100%'}">
                <div class="menu_list">
                    <router-link :to="item.url" class="td_none rl ml_item il_block" v-for="(item, index) in menuArr" :key="index">
                        <div class="">
                            {{ item.name }}
                        </div>
                    </router-link>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
    let old_scroll = 0;
    export default {
        name: "mslNav",
        data() {
            return {
                showNav: true,
                show: false,
                scroll: 0, // 滚动高度
                old_scroll: 0, // 滚动高度（旧）
                menuArr: [
                    {
                        name: '首页',
                        url: './'
                    },
                    {
                        name: '产品分类',
                        url: './production'
                    },
                    {
                        name: '相关资讯',
                        url: './news'
                    },
                    {
                        name: '公司信息',
                        url: './company_info'
                    },
                    {
                        name: '联系我们',
                        url: './contact'
                    },
                    {
                      name: '英文官网',
                      url: './en'
                    },
                ]
            }
        },
        mounted() {
            window.addEventListener('scroll',this.handleScroll)
        },
        methods: {
            showPopup() {
                this.show = true;
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop;
                if (this.scroll > 20) {
                    this.toggerNavStatus();
                } else {
                    this.showNav = true;
                }
                this.old_scroll = this.scroll;
            },
            toggerNavStatus () {
                this.showNav = this.scroll > this.old_scroll ? false : true;
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 导航栏 */
    .show_nav {
        height: 50px;
    }
    .hide_nav {
        height: 0;
    }
    .nav {
        width: 100%;
        /*height: 50px;*/
        padding: 0 16px;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        z-index: 100;
        background-color: #fff;
        .logo_box {
            width: 133px;
            height: 32px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .menu_box {
            .menu {
                font-size: 24px;
                color: #000;
            }
        }
    }
    .distance {
        width: 100%;
        height: 50px;
    }

    /* 菜单弹窗 */
    .menu_popup {
        &::v-deep {
            .van-popup {
                background-color: rgba(0, 0, 0, .8);
                .van-popup__close-icon {
                    color: #fff;
                }
            }
        }
    }
    .menu_list {
        width: 100%;
        height: 100%;
        padding: 1px 32px;
        box-sizing: border-box;
        .ml_item {
            width: 100%;
            padding: 24px 0;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(255, 255, 255, .3);
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 24px;
            color: #FFFFFF;
            .rl {
                width: 100%;
                height: 100%;
                color: #fff;
            }
            &:last-child {
                border-bottom: 0;
            }
            &:first-child {
                margin-top: 150px;
            }
        }
    }
</style>
